import './index.scss';
import { useTranslation } from 'react-i18next';
import { CancellationPolicy } from '../../../../store/PolicyManagement/policyManagementTypes';

type PropsTypes = {
  policy: CancellationPolicy;
};

const CancellationPolicyInfo = (props: PropsTypes) => {
  const { t } = useTranslation();

  return (
    <div className="cancellation-policy-info">
      <div className="cancellation-policy-info-title">
        {t('CANCELLATION_POLICY_INFO_TITLE')}
      </div>
      <div className="cancellation-policy-info-description">
        {props.policy.description}
      </div>
    </div>
  );
};

export default CancellationPolicyInfo;
